import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/books/_components/ClientSideBooksWrapper/ClientSideBooksWrapper.tsx");
